import { Controller } from "stimulus"

// #1858: de tabbladen van het trainerprofiel. De server toont al het tabblad
// uit ?tab=; dit wisselt zonder te herladen, zet het tabblad in de url (zodat
// verversen erop blijft) en opent het tabblad met het anker uit de url
// (#roosterkleur na opslaan van de kleur). Zonder JavaScript is elke tab een
// gewone link.
export default class extends Controller {
  static targets = ["tab", "paneel"]
  static values = { standaard: String }

  connect() {
    const anker = window.location.hash.slice(1)
    if (!anker) return

    const doel = document.getElementById(anker)
    const paneel = doel && this.paneelTargets.find((kandidaat) => kandidaat.contains(doel))
    if (paneel) this.toon(paneel.dataset.tabPaneel, false)
  }

  kies(event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

    const naam = event.currentTarget.dataset.tab
    if (!this.paneelTargets.some((paneel) => paneel.dataset.tabPaneel === naam)) return

    event.preventDefault()
    this.toon(naam, true)
    if (!this.tabTargets.includes(event.currentTarget)) {
      this.tabTargets.find((tab) => tab.dataset.tab === naam)?.scrollIntoView({ block: "nearest", inline: "nearest" })
    }
  }

  toets(event) {
    const stap = { ArrowRight: 1, ArrowLeft: -1 }[event.key]
    if (!stap) return

    event.preventDefault()
    const huidig = this.tabTargets.indexOf(event.currentTarget)
    const volgende = this.tabTargets[(huidig + stap + this.tabTargets.length) % this.tabTargets.length]
    this.toon(volgende.dataset.tab, true)
    volgende.focus()
  }

  toon(naam, inUrl) {
    this.tabTargets.forEach((tab) => {
      const actief = tab.dataset.tab === naam
      tab.classList.toggle("is-actief", actief)
      tab.setAttribute("aria-selected", actief ? "true" : "false")
      tab.tabIndex = actief ? 0 : -1
    })
    this.paneelTargets.forEach((paneel) => { paneel.hidden = paneel.dataset.tabPaneel !== naam })
    // #1996: Mijn Training is licht, de rest van het profiel donker
    this.element.classList.toggle("cc-licht", naam === "mijn_training")
    if (inUrl) this.zetInUrl(naam)
  }

  zetInUrl(naam) {
    const url = new URL(window.location.href)
    if (naam === this.standaardValue) {
      url.searchParams.delete("tab")
    } else {
      url.searchParams.set("tab", naam)
    }
    url.hash = ""
    window.history.replaceState(window.history.state, "", url.toString())
  }
}
